import { createRootRoute } from '@tanstack/react-router';
import { isReactDevelopment } from 'prid-extended-material/utils';
import MainLayout from '#ui/RootLayout';
import React, { Suspense } from 'react';

const TanStackRouterDevtools = isReactDevelopment()
  ? React.lazy(() =>
      import('@tanstack/router-devtools').then(res => ({
        default: res.TanStackRouterDevtools,
      })),
    )
  : () => null;

const rootRoute = createRootRoute({
  component: () => (
    <Suspense>
      <MainLayout />
      <TanStackRouterDevtools />
    </Suspense>
  ),
});

export { rootRoute };
